<template>
  <div class="d-flex">
      <label class="switch">
          <input type="checkbox" class="on-off-toggler" :checked="boolValue"
              @click="emitToggle()" :disabled="disabled">
          <span class="slider round"></span>
      </label>
      <h4 class="mt-1 mr-0">{{heading}}</h4>
  </div>
</template>
<script>
export default {
  props: ['heading', 'boolValue', 'type', 'id', 'disabled'],
  methods:{
    emitToggle(){
      this.$emit("emitToggle", this.type, !this.boolValue, this.id)
    }
  }
}
</script>